import React from 'react';

import { ToastContainer as ToastContainerBootstrap } from 'react-bootstrap';

import Toast from './Toast';

export interface ToastMessage {
  id: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  title: string;
  description?: string;
}

interface ToastContainerProps {
  messages: ToastMessage[];
}

const ToastContainer: React.FC<ToastContainerProps> = ({ messages }): any => {
  return (
    <ToastContainerBootstrap position="top-end" className="p-3">
      {messages.map((message) => (
        <Toast key={message.id} message={message} />
      ))}
    </ToastContainerBootstrap>
  );
};

export default ToastContainer;
